import React, { useState } from "react";

import SubscriptionDetails from "./subscription";
import Subscription from "../../../actions/Subscription";
import { useEffect } from "react";
import { isAuth } from "../../../actions/auth";
import Notify from "../../../components/customHelpers/Notify";
import Notification from "../../../components/customHelpers/Notification";
import Loading from "../../../components/customHelpers/Loading";
import Layout from "../../../components/layout/Layout";
import Admin from "../../../components/auth/Admin";
const Subscriptions = () => {
  const [subscription, setSubscription] = useState(null);
  const { viewOrgSubscription } = Subscription();

  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;
  const { NotifyMessage, notify, setNotify } = Notify();

  useEffect(() => {
    getAllSubscriptions();
  }, [reload]);
  const getAllSubscriptions = () => {
    setValues({ ...values, loading: true });

    viewOrgSubscription(isAuth()?.staffOrganizations[0]?.organization?.id).then(
      (data) => {
        if (data.err) {
          NotifyMessage({
            message: data.err,
            type: "error",
          });
          setValues({ ...values, loading: false });
        } else if (data.subscription) {
          setSubscription(data.subscription);
          setValues({ ...values, loading: false });
        }
      }
    );
  };
  return (
    <Layout>
      <Admin>
        {loading ? (
          <Loading />
        ) : (
          <>
            <SubscriptionDetails subscriptionData={subscription} />
            <Notification notify={notify} setNotify={setNotify} />
          </>
        )}
      </Admin>
    </Layout>
  );
};

export default Subscriptions;
